interface IAttentionIconProps {
  color?: string;
  className?: string;
}

const SettingsIcon: React.FC<IAttentionIconProps> = ({ color, className }) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g transform="translate(.54 .089)" fill="none" fillRule="evenodd">
      <rect
        style={{ fill: `${color || 'var(--tt-yellow)'}` }}
        x="10.04"
        y="5.02"
        width="5.02"
        height="50.201"
        rx="1"
      />
      <rect
        style={{ fill: `${color || 'var(--tt-yellow)'}` }}
        x="27.61"
        y="5.02"
        width="5.02"
        height="50.201"
        rx="1"
      />
      <rect
        style={{ fill: `${color || 'var(--tt-yellow)'}` }}
        x="45.181"
        y="5.02"
        width="5.02"
        height="50.201"
        rx="1"
      />
      <circle style={{ fill: `${color || 'var(--tt-dark-purple)'}` }} cx="12.55" cy="20.08" r="7.53" />
      <circle style={{ fill: `${color || 'var(--tt-dark-purple)'}` }} cx="30.12" cy="40.16" r="7.53" />
      <circle style={{ fill: `${color || 'var(--tt-dark-purple)'}` }} cx="47.691" cy="30.12" r="7.53" />
    </g>
  </svg>
);

export default SettingsIcon;
